import { render, staticRenderFns } from "./PaymentConfirmation.vue?vue&type=template&id=f66ad620&scoped=true&"
import script from "./PaymentConfirmation.vue?vue&type=script&lang=js&"
export * from "./PaymentConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PaymentConfirmation.vue?vue&type=style&index=0&id=f66ad620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f66ad620",
  null
  
)

export default component.exports